import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from '@ngneat/transloco';
import { ModalResult } from '@shared/models/ModalResult';

@Component({
  standalone: false,
  selector: 'app-fcsc-series-config-delete-confirmation',
  templateUrl: './fcsc-series-config-delete-confirmation.component.html',
  styleUrls: ['./fcsc-series-config-delete-confirmation.component.scss'],
})
export class FcscSeriesConfigDeleteConfirmationComponent {
  @Input() message!: string;
  title!: string;

  constructor(
    public activeModal: NgbActiveModal,
    public translocoService: TranslocoService
  ) {
    this.title = this.translocoService.translate(
      "modules.admin-section.config-modal.delete-serie-title"
    );
  }

  deleteSerie(): void {
    const result = {
      ok: ModalResult.DELETE_OK,
    };
    this.activeModal.close(result);
  }

  cancel(): void {
    const result = {
      cancel: ModalResult.DELETE_CANCEL,
    };
    this.activeModal.close(result);
  }
}
